<template>
  <div v-show="!showTableExample">
    <div class="frame-wrapper">
      <div class="th"></div>
      <div class="th-wrapper">
        <div class="th">販売開始前</div>
        <div class="th">{{ $filters.nan2num( startYear ) }}/{{ $filters.nan2num( startMonth ) }}～{{ $filters.nan2num( endYear ) }}/{{ $filters.nan2num( endMonth ) }}</div>
      </div>
      <div class="th-wrapper">
        <div class="th">1年目</div>
        <div class="th">{{ $filters.nan2num( launchYear ) }}/{{ $filters.nan2num( launchMonth ) }}〜{{ $filters.nan2num( endYear1 ) }}/{{ $filters.nan2num( endMonth1 ) }}</div>
      </div>
      <div class="th-wrapper">
        <div class="th">2年目</div>
        <div class="th">{{ $filters.nan2num( startYear2 ) }}/{{ $filters.nan2num( startMonth2 ) }}〜{{ $filters.nan2num( endYear2 ) }}/{{ $filters.nan2num( endMonth2 ) }}</div>
      </div>
      <div class="th-wrapper">
        <div class="th">3年目</div>
        <div class="th">{{ $filters.nan2num( startYear3 ) }}/{{ $filters.nan2num( startMonth3 ) }}〜{{ $filters.nan2num( endYear3 ) }}/{{ $filters.nan2num( endMonth3 ) }}</div>
      </div>
    </div>
    <div class="frame-wrapper">
      <div class="th">①売上</div>
      <div class="td"> - </div>
      <div class="td">{{ currencyFormat( year1TotalSales / unit )  }}</div>
      <div class="td">{{ currencyFormat( year2TotalSales / unit ) }}</div>
      <div class="td">{{ currencyFormat( year3TotalSales / unit ) }}</div>
    </div>
    <div class="frame-wrapper">
      <div class="th">②売上原価</div>
      <div class="td"> - </div>
      <div class="td">{{ currencyFormat( year1TotalSalesCost / unit ) }}</div>
      <div class="td">{{ currencyFormat( year2TotalSalesCost / unit ) }}</div>
      <div class="td">{{ currencyFormat( year3TotalSalesCost / unit ) }}</div>
    </div>
    <div class="frame-wrapper">
      <div class="th"><span>③</span>売上総利益 (①－②)<br/>(売上比 %)</div>
      <div class="td"> - </div>
      <div class="td">{{ currencyFormat( (year1TotalSales - year1TotalSalesCost) / unit ) }}<br/>({{ toSigned(percentage((year1TotalSales - year1TotalSalesCost), year1TotalSales)) }})</div>
      <div class="td">{{ currencyFormat( (year2TotalSales - year2TotalSalesCost) / unit ) }}<br/>({{ toSigned(percentage((year2TotalSales - year2TotalSalesCost), year2TotalSales)) }})</div>
      <div class="td">{{ currencyFormat( (year3TotalSales - year3TotalSalesCost) / unit ) }}<br/>({{ toSigned(percentage((year3TotalSales - year3TotalSalesCost), year3TotalSales)) }})</div>
    </div>
    <div class="frame-wrapper">
      <div class="th">④販売費・一般管理費</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -beforeSalesManagementCost / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year1SalesManagementCost / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year2SalesManagementCost / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year3SalesManagementCost / unit ) ) }}</div>
    </div>
    <div class="frame-wrapper">
      <div class="th">&nbsp;&nbsp;&nbsp;&nbsp;人件費</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -beforePersonnelExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year1PersonnelExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year2PersonnelExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year3PersonnelExpense / unit ) ) }}</div>
    </div>
    <div class="frame-wrapper">
      <div class="th">&nbsp;&nbsp;&nbsp;&nbsp;広告宣伝費</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -beforeAdvertisingExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year1AdvertisingExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year2AdvertisingExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year3AdvertisingExpense / unit ) ) }}</div>
    </div>
    <div class="frame-wrapper">
      <div class="th">&nbsp;&nbsp;&nbsp;&nbsp;研究開発・設備投資費</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -beforeNonAssetInvestmentCost / unit ) ) }} </div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -(year1InvestmentCost + year1NonAssetInvestmentCost) / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -(year2InvestmentCost + year2NonAssetInvestmentCost) / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -(year3InvestmentCost + year3NonAssetInvestmentCost) / unit ) ) }}</div>
    </div>
    <div class="frame-wrapper">
      <div class="th">&nbsp;&nbsp;&nbsp;&nbsp;家賃・水道光熱費など</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -beforeLifeExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year1LifeExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year2LifeExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year3LifeExpense / unit ) ) }}</div>
    </div>
    <div class="frame-wrapper">
      <div class="th">&nbsp;&nbsp;&nbsp;&nbsp;その他経費</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -beforeOtherExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year1OtherExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year2OtherExpense / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( -year3OtherExpense / unit ) ) }}</div>
    </div>
    <div class="frame-wrapper">
      <div class="th"><span>⑤</span>営業利益 (③－④)<br/>(売上比 %)</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( beforeOperatingProfitTotal / unit ) ) }}</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( year1OperatingProfitTotal / unit ) ) }}<br/>({{ $filters.nan2str( toSigned(percentage(year1OperatingProfitTotal, year1TotalSales)) ) }})</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( year2OperatingProfitTotal / unit ) ) }}<br/>({{ $filters.nan2str( toSigned(percentage(year2OperatingProfitTotal, year2TotalSales)) ) }})</div>
      <div class="td">{{ $filters.nan2dash( currencyFormat( year3OperatingProfitTotal / unit ) ) }}<br/>({{ $filters.nan2str( toSigned(percentage(year3OperatingProfitTotal, year3TotalSales)) ) }})</div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import VueTypes from 'vue-types'
  import PL from './profit-and-loss'

  export default {
    mixins: [PL],

    name: 'ProfitAndLossTableV5',

    props: {
      showTableExample: VueTypes.bool.def(false)
    },

    data () {
      return {}
    },

    computed: {
    },

    methods: {

      percentage (dividend, divisor) {
        if (_.toInteger(divisor) === 0) {
          return 0
        } else {
          return dividend / divisor * 100
        }
      },
    }
  }
</script>
